/* R&B start page sections: films play only while visible (also on iPhone: muted + playsinline are set before play),
   with 'Reduce motion' on they still play but a pause button shows; pause button,
   rails: thin progress line + drag with the mouse. Loaded once (guard), works for sections added in the editor. */
(function () {
  if (window.RbHome) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { var v = e.target; if (e.isIntersecting && !v.rbPaused) { v.play && v.play().catch(function () {}); } else if (v.pause) v.pause(); });
  }, { threshold: 0.15 }) : null;
  // Films start downloading about two screens before they are reached, so they are already playing when they come into view
  // (Carl, 6 Oct: waiting until a film was on screen left it black too long).
  function warm(v) { if (v.rbWarm || v.offsetParent === null) return; v.rbWarm = true; v.preload = 'auto'; try { v.load(); } catch (e) {} }
  var near = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { warm(e.target); near.unobserve(e.target); } });
  }, { rootMargin: '200% 0px' }) : null;

  function initSection(sec) {
    if (!sec || sec.rbInit) return; sec.rbInit = true;
    var vids = Array.prototype.slice.call(sec.querySelectorAll('[data-rbk-video] video'));
    vids.forEach(function (v) {
      // films inside a link (tiles, lookbook) have no pause button: with 'Reduce motion' they stay on the first frame
      if (reduce.matches && v.closest('[data-rbk-still]')) { v.preload = 'metadata'; return; }
      // iOS only autoplays muted, inline films: set it all before the first play()
      v.muted = true; v.defaultMuted = true; v.setAttribute('muted', ''); v.playsInline = true;
      v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
      v.loop = true;
      // only the version on screen (desktop or phone film) downloads; the first film starts at once, as before 6 Oct
      if (v.offsetParent !== null && v.getBoundingClientRect().top < window.innerHeight * 1.5) { v.setAttribute('autoplay', ''); warm(v); }
      else if (near) near.observe(v); else warm(v);
      if (io) io.observe(v); else v.play && v.play().catch(function () {});
    });
    // each pause button controls the films next to it (a section can hold several, e.g. tiles or a lookbook)
    sec.querySelectorAll('[data-rbk-pause]').forEach(function (btn) {
      var mine = vids.filter(function (v) { return btn.parentNode.contains(v); });
      if (!mine.length) mine = vids;
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var paused = btn.getAttribute('aria-pressed') !== 'true';
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        mine.forEach(function (v) {
          v.rbPaused = paused;
          if (paused) v.pause(); else if (v.offsetParent !== null) v.play().catch(function () {});
        });
      });
    });
    sec.querySelectorAll('[data-rbk-rail]').forEach(rail);
  }

  function rail(row) {
    var thumb = row.parentNode.querySelector('[data-rbk-thumb]');
    function upd() {
      if (!thumb) return;
      var max = row.scrollWidth - row.clientWidth;
      var w = row.scrollWidth ? Math.max(12, Math.min(100, row.clientWidth / row.scrollWidth * 100)) : 100;
      thumb.style.width = w + '%';
      thumb.style.left = (max > 0 ? row.scrollLeft / max * (100 - w) : 0) + '%';
      thumb.parentNode.style.visibility = max > 2 ? '' : 'hidden';
    }
    row.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
    // drag with a mouse (touch and trackpads scroll natively)
    var down = false, moved = false, x0 = 0, s0 = 0;
    row.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; x0 = e.clientX; s0 = row.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - x0;
      if (!moved && Math.abs(dx) > 5) { moved = true; row.classList.add('is-drag'); }
      if (moved) row.scrollLeft = s0 - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return; down = false;
      if (moved) {
        // settle on the nearest card, calmly
        setTimeout(function () { row.classList.remove('is-drag'); }, 0);
        var first = row.firstElementChild; if (!first) return;
        var step = first.getBoundingClientRect().width + parseFloat(getComputedStyle(row).columnGap || 0);
        if (step > 0) row.scrollTo({ left: Math.round(row.scrollLeft / step) * step, behavior: reduce.matches ? 'auto' : 'smooth' });
      }
    });
    row.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);
    row.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  // picture-or-film fields outside the start page sections (Journal feature, Our story, Made to Measure, stores) have no
  // data-rbk-section around them: their own box is used
  function scan() {
    document.querySelectorAll('[data-rbk-section]').forEach(initSection);
    document.querySelectorAll('.rbk-media').forEach(function (m) { if (!m.closest('[data-rbk-section]')) initSection(m.parentNode); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', function (e) { var s = e.target.querySelector('[data-rbk-section]'); initSection(s); });
  window.RbHome = { scan: scan };
})();

/* Shop the look: point ↔ product row highlight */
(function () {
  function set(sec, i) {
    sec.querySelectorAll('[data-rbk-hs]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-rbk-hs') === i); });
    sec.querySelectorAll('[data-rbk-lk]').forEach(function (a) { a.classList.toggle('is-on', a.getAttribute('data-rbk-lk') === i); });
  }
  document.addEventListener('click', function (e) {
    var hs = e.target.closest && e.target.closest('[data-rbk-hs]');
    if (!hs) return;
    var sec = hs.closest('[data-rbk-look]'); var i = hs.getAttribute('data-rbk-hs');
    set(sec, i);
    var row = sec.querySelector('[data-rbk-lk="' + i + '"]');
    if (row && window.matchMedia('(max-width: 989px)').matches) row.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  });
  document.addEventListener('mouseover', function (e) {
    var t = e.target.closest && e.target.closest('[data-rbk-hs], [data-rbk-lk]');
    if (!t) return;
    var sec = t.closest('[data-rbk-look]'); if (!sec) return;
    set(sec, t.getAttribute('data-rbk-hs') || t.getAttribute('data-rbk-lk'));
  });
})();

/* R&B · Recently viewed (sections/rb-recent): fills the rail from the visitor's own list, or stays hidden */
(function () {
  if (window.RbRecent) return;
  function root() { var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; return r.charAt(r.length - 1) === '/' ? r : r + '/'; }
  function list() {
    try {
      return JSON.parse(localStorage.getItem('rb_recently_viewed') || '[]')
        .filter(function (r) { return r && r.h && Date.now() - (r.ts || 0) < 60 * 864e5; });
    } catch (e) { return []; }
  }
  function card(h) {
    var key = 'rbrc:' + root() + ':' + h;
    try { var c = sessionStorage.getItem(key); if (c !== null) return Promise.resolve(c); } catch (e) {}
    return fetch(root() + 'products/' + encodeURIComponent(h) + '?view=rb-card', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) { html = String(html || '').trim(); if (html.indexOf('rbk-card') < 0) html = ''; try { sessionStorage.setItem(key, html); } catch (e) {} return html; })
      .catch(function () { return ''; });
  }
  function fill(box) {
    if (!box || box.rbDone) return; box.rbDone = true;
    var row = box.querySelector('[data-rbk-recent-row]');
    var limit = +box.getAttribute('data-limit') || 8, min = +box.getAttribute('data-min') || 2;
    var items = list().slice(0, limit);
    if (items.length < min || !row) return;
    Promise.all(items.map(function (r) { return card(r.h); })).then(function (htmls) {
      var t = document.createElement('template');
      t.innerHTML = htmls.join('');
      var cards = t.content.querySelectorAll('.rbk-card');
      if (cards.length < min) return; // sold-out or removed products drop out
      row.appendChild(t.content);
      box.hidden = false;
      window.dispatchEvent(new Event('resize')); // the rail line measures itself
    });
  }
  function scan() { document.querySelectorAll('[data-rbk-recent]').forEach(fill); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', function (e) { fill(e.target.querySelector('[data-rbk-recent]')); });
  window.RbRecent = { scan: scan };
})();

/* Same-page links to an R&B section (e.g. "Order now" → #order on the champagne page, Carl 7 Oct) glide there
   instead of jumping; at once with reduced motion. The section stops just under the header (scroll-margin-top in rb-home.css). */
(function () {
  if (window.RbAnchors) return; window.RbAnchors = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href*="#"]'); if (!a) return;
    var u; try { u = new URL(a.getAttribute('href'), location.href); } catch (err) { return; }
    // the same page also under a language or market path (/de/pages/champagne, /en-de/…)
    function bare(p) { return p.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i, '').replace(/\/$/, ''); }
    if (u.origin !== location.origin || bare(u.pathname) !== bare(location.pathname) || !u.hash || u.hash.length < 2) return;
    var t; try { t = document.getElementById(decodeURIComponent(u.hash.slice(1))); } catch (err) { return; }
    if (!t || !t.hasAttribute('data-rbk-section')) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', u.hash);
  });
})();
